import React from "react";

function Loader() {
  return (
    <div className="flex h-full w-full justify-center items-center">
      <div className="loader text-primary dark:text-primaryYellow"></div>
    </div>
  );
}

export default Loader;
